const pagesIndividualDevicesEn = {
  headers: {
    assetTag: 'Asset tag',
    assignee: 'Assigned to',
    deviceTag: 'Device tag',
    genre: 'Type',
    model: 'Model',
    name: 'Device',
    status: 'Status'
  },
  pageTitle: 'Devices',
  tabs: {
    managedPlace: 'Devices at sites I manage',
    self: 'My devices'
  }
};
export default pagesIndividualDevicesEn;